import log from "cslog";
import { VIEWERS } from "../data/extra/viewerData";
import {
    bookInfoState,
    bookLayoutState,
    colorThemeState,
    creationTypeState,
    currentBookPageState,
    currentContextState,
    customDomainState,
    fixedLogoThemeState,
    inverseLogoThemeState,
    isThemeableState,
    layoutTypeState,
    slugState,
    titleState,
    urlSettingsState,
    usedSchemasState,
} from "../db/bookConfig";
import {
    globalVariablesConfigState,
    globalVariablesState,
    ogColorsState,
} from "../db/dataDb";
import {
    globalConfigState,
    gstyleState,
    themeColorState,
    themeFontSetState,
    themePageState,
} from "../db/gstyleDb";
import {
    DEFAULT_ROLE_LIST,
    enablePermissionsState,
    permissionsPageState,
    protectedAccessState,
    rolesState,
} from "../db/permissions";
import { seoBasicState } from "../db/seoDb";
import {
    extensionSettingsState,
    installedExtensionsState,
} from "../db/storeDb";
import { viewerState } from "../db/viewerDb";
import { decodeMagazineData } from "./magazine/decode";
import { decodeWebsiteData } from "./website/decode";

export const decodeData = async (data, set, snapshot) => {
    const info = data.info;
    // const etype = info.type;
    const etype = data.type;

    log.h4(`Decoding ${etype}`);

    // await set(organizationState, data.organization);
    await set(currentContextState, {
        organization: data.organization,
        person: data.person || { id: "d5f301f3-52a6-4025-a774-5397138cac36" },
    });

    await set(titleState, data.title);

    await set(slugState, data.slug);

    await set(customDomainState, data.custom_domain);

    await set(creationTypeState, data.creation_type);

    await set(urlSettingsState, data.urlsettings);

    await set(isThemeableState, data.is_themeable);

    await set(colorThemeState, data.theme);

    await set(fixedLogoThemeState, data.fixed_logo_theme);

    await set(bookInfoState, info);

    await set(layoutTypeState, info?.layout);

    await set(currentBookPageState, { pid: info.startPageId || "firstPage" });

    await set(bookLayoutState, data.layout);

    const gconfig = data.gconfig.gconfig;
    await set(themeColorState, gconfig.colors);
    await set(themeFontSetState, gconfig.fontSets);
    if (gconfig.page) {
        await set(themePageState, gconfig.page);
    }

    // const gstyles = data.gconfig.gstyles; //WATCH_OUT: if it break somethings.
    const gstyles = data.gconfig.gstyles?.gstyles;
    for (let key in gstyles) {
        // if (key === "config") {
        //     continue;
        // }
        log.d(key, "Now setting gstyle key:");
        await set(gstyleState(key), gstyles[key]);
    }

    const globalConfig = data.gconfig.globalConfig;
    await set(globalConfigState, globalConfig);

    const seo = data.seo;
    await set(seoBasicState, seo);

    const used_schemas = data.used_schemas;
    const out_schemas = {};
    used_schemas.forEach((item) => {
        out_schemas[item?.qdb_creation_schema_id?.id] =
            item?.qdb_creation_schema_id;
    });
    log.d(out_schemas, "out schemas");
    await set(usedSchemasState, out_schemas);

    // Global vars
    const globalVariables = data.others.globalVariables || {};
    if (
        !Object.keys(globalVariables).includes("organization") &&
        data.organization?.id
    ) {
        globalVariables["organization"] = data.organization?.id;
    }
    if (
        info?.typebase === "multipage" &&
        !Object.keys(globalVariables).includes("pageNo")
    ) {
        globalVariables["pageNo"] = 1;
    }
    await set(globalVariablesState, globalVariables);

    const globalVariablesConfig = data.others.globalVariablesConfig || {};
    if (
        !Object.keys(globalVariablesConfig).includes("organization") &&
        data.organization?.id
    ) {
        globalVariablesConfig["organization"] = {
            name: "organization",
            vtype: "text",
            itype: "text",
            default_value: null,
        };
    }

    const og_colors = data.others.ogColors;
    await set(ogColorsState, og_colors);

    // add page no for flipbook
    if (
        info?.typebase === "multipage" &&
        !Object.keys(globalVariablesConfig).includes("pageNo")
    ) {
        globalVariablesConfig["pageNo"] = {
            name: "pageNo",
            vtype: "text",
            itype: "text",
            default_value: 1,
        };
    }
    await set(globalVariablesConfigState, globalVariablesConfig);
    // -------------------------------

    const extensionSettings = data.others.extensionSettings || {};
    await set(extensionSettingsState, extensionSettings);

    const permissions_settings = data.permissions;
    await set(enablePermissionsState, !!permissions_settings.enable);
    await set(
        rolesState,
        permissions_settings.roles?.length > 0
            ? permissions_settings.roles
            : DEFAULT_ROLE_LIST
    );
    await set(permissionsPageState, permissions_settings.page_permissions);

    await set(
        protectedAccessState,
        permissions_settings.protected_access || {
            enabled: false,
            password: "qureal",
        }
    );

    // Always update viewer config params
    const viewer = data.viewers;
    const newViewer = VIEWERS[etype] || VIEWERS["default"];
    let updatedViewer = {
        input: {
            ...newViewer.input,
            ...viewer?.input,
        },
        itype: {
            ...newViewer.itype,
            ...viewer?.itype,
        },
    };
    await set(viewerState, updatedViewer);

    const extensions = data.extensions || {};
    await set(installedExtensionsState, (old_exts) => {
        const new_exts = {};
        Object.keys(extensions).forEach((key) => {
            if (!(key in old_exts)) {
                new_exts[key] = extensions[key];
            }
        });
        return {
            ...old_exts,
            ...new_exts,
        };
    });

    // const preinstalled_extensions= await snapshot.getPromise(installedExtensionsState)
    //========================================

    if (
        info.layout === "responsive" ||
        info.layout === "grid" ||
        info.layout === "document"
    ) {
        await decodeWebsiteData(data, set);
    } else if (info.layout === "absolute") {
        await decodeMagazineData(data, set);
    }
    // if (etype === "magazine") {
    //     await decodeMagazineData(data, set);
    // } else if (etype === "website") {
    //     await decodeWebsiteData(data, set);
    // } else if (etype === "ad") {
    //     await decodeAdData(data, set);
    // }
};
